export default function createElement(htmlString){
	// Returns an html element created from a string
	// or an array of html elements if there is more than 
	// one starting node in the string
	let result = $.parseHTML($.trim(htmlString));

	result = result.filter(element => !isWhitespaceNode(element));
	result.forEach(element => removeWhitespace(element))

	if(result.length == 1){
		return result[0];
	}
	return result;
}

function removeWhitespace(element){
	if(isWhitespaceNode(element) && element.parentElement){
		element.parentElement.removeChild(element);
	}
	else{
		for (const childElement of element.childNodes) {
			removeWhitespace(childElement);
		}
	}
}

function isWhitespaceNode(element){
	if(element.nodeType == 3){
		// Is text node
		const content = element.textContent.replace(/\s/g,'');
		if(!content)
			return true;
	}
	return false;
}